"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigType = void 0;
var ConfigType;
(function (ConfigType) {
    ConfigType[ConfigType["WHITELIST"] = 0] = "WHITELIST";
    ConfigType[ConfigType["BLACKLIST"] = 1] = "BLACKLIST";
})(ConfigType = exports.ConfigType || (exports.ConfigType = {}));
//# sourceMappingURL=types.js.map